import React from "react";
import { productsImage } from "../mock";
import { Award, Leaf, Droplet } from "lucide-react";

const Products = () => {
  const values = [
    {
      icon: Award,
      title: "EXPERTISE & SAVOIR-FAIRE",
      desc: "Une marque professionnelle présente depuis 1925, synonyme de qualité et de confiance."
    },
    {
      icon: Leaf,
      title: "DES FORMULES DE QUALITÉ",
      desc: "Des produits performants, agréables à utiliser et adaptés à chaque besoin."
    },
    {
      icon: Droplet,
      title: "ENGAGEMENT RESPONSABLE",
      desc: "Peggy Sage s'engage pour des formules toujours plus respectueuses et des emballages plus responsables."
    }
  ];

  const usages = [
    "SOINS DU VISAGE",
    "SOINS DU CORPS",
    "MASSAGES",
    "EXTENSIONS DE CILS",
    "REHAUSSEMENT DE CILS",
    "ÉPILATIONS"
  ];

  return (
    <section id="produits" className="py-24 md:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-start">
          {/* Left */}
          <div>
            <p className="font-serif text-[11px] tracking-[0.35em] text-gold-dark mb-6">
              MAISON MORGANE &nbsp; • &nbsp; BEAUTÉ & BIEN-ÊTRE
            </p>
            <h2 className="font-serif text-4xl md:text-5xl text-brown leading-tight mb-2">
              L'exigence de la
            </h2>
            <h2 className="font-serif text-5xl md:text-7xl text-brown leading-none mb-2">
              QUALITÉ,
            </h2>
            <p className="font-serif text-3xl md:text-4xl text-brown mb-1">
              au cœur de votre
            </p>
            <p className="font-vibes text-5xl md:text-6xl text-gold-dark mb-8">
              expérience
            </p>

            <div className="gold-divider my-6" style={{ justifyContent: "flex-start" }}>
              <span className="w-12 h-px bg-gold/60" />
            </div>

            <p className="font-cormorant text-brown/85 text-lg leading-relaxed mb-8">
              Chez Maison Morgane, chaque détail compte. C'est pourquoi j'ai choisi de travailler avec <span className="font-semibold">Peggy Sage</span>, une marque professionnelle reconnue dans l'univers de la beauté et de l'esthétique depuis 1925.
            </p>

            <div className="bg-sand p-6 border-l-2 border-gold">
              <p className="font-serif text-[11px] tracking-[0.3em] text-brown mb-4">
                J'UTILISE LEURS GAMMES PROFESSIONNELLES POUR :
              </p>
              <div className="grid grid-cols-2 gap-y-2">
                {usages.map((u, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold" />
                    <span className="font-serif text-[11px] tracking-[0.2em] text-brown">{u}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right image + brand */}
          <div className="relative">
            <div className="overflow-hidden">
              <img
                src={productsImage}
                alt="Peggy Sage products"
                className="w-full h-[550px] md:h-[720px] object-cover"
              />
            </div>
            <div className="absolute top-6 right-6 md:top-10 md:right-10 bg-cream/95 backdrop-blur px-6 py-5 border border-gold/30 shadow-sm">
              <p className="font-serif text-2xl text-brown text-center leading-none">Peggy</p>
              <p className="font-vibes text-3xl text-gold-dark text-center leading-none mb-1">Sage</p>
              <p className="font-serif text-[9px] tracking-[0.25em] text-brown text-center">PARIS</p>
              <div className="mt-3 pt-3 border-t border-gold/30">
                <p className="font-serif text-[9px] tracking-[0.25em] text-brown text-center">MARQUE PROFESSIONNELLE</p>
                <p className="font-serif text-[9px] tracking-[0.25em] text-brown text-center">DEPUIS 1925</p>
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {values.map((v, i) => (
            <div key={i} className="bg-sand p-8 text-center">
              <div className="w-14 h-14 rounded-full border border-gold/40 flex items-center justify-center mx-auto mb-5">
                <v.icon size={20} className="text-gold-dark" strokeWidth={1.3} />
              </div>
              <p className="font-serif text-[11px] tracking-[0.3em] text-brown mb-3">{v.title}</p>
              <p className="font-cormorant text-brown/75 text-[15px] leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <div className="gold-divider mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          </div>
          <p className="font-cormorant italic text-brown text-xl md:text-2xl">
            « Prendre soin de vous, c'est aussi choisir<br /> ce qu'il y a de mieux pour votre peau. »
          </p>
        </div>
      </div>
    </section>
  );
};

export default Products;
